import styled from 'styled-components'

export const ActionsContainer = styled.div`
  margin-top: 24px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
